export default "/images/media.jpg?1501c561287555ad33964fd194e5c412";